import useQuery from '../useQuery';

/** M31 (#491): the FULL detail of one fulfillment — the carrier `label_url` plus
 * the newest-first parcel-event timeline (`events`). Single-object endpoint
 * (never used in a many/list context). Any member can read. Mirrors
 * `useShippingConnectionQuery` (same wrapper + read shape). */
function useFulfillmentDetailQuery(sellerId, fulfillmentId, params) {
  return useQuery(`/shipping/${sellerId}/fulfillments/${fulfillmentId}/`, {
    enabled: Boolean(sellerId && fulfillmentId),
    ...params,
  });
}

export default useFulfillmentDetailQuery;
